import { EQUIPMENT } from '../../prototype/data/catalog.ts'
import { productionWrite } from '../production/actions.ts'

export const setEquipmentRepair = (id: string, reason: string | null) =>
  productionWrite(
    `equipment:${id}`,
    '/equipment/repair',
    () => ({
      id,
      version: (EQUIPMENT.find((machine) => machine.id === id) as { version?: number } | undefined)
        ?.version,
      reason,
    }),
    'PATCH',
  )
